import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { waLink } from "../config";

const EASE = [0.16, 1, 0.3, 1];
const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.7, ease: EASE },
};

const PLANS = [
  {
    id: "mensal",
    name: "Mensal",
    price: "R$ 149,90",
    period: "/mês",
    note: "Sem fidelidade — cancele quando quiser.",
    features: [
      "Treino 100% personalizado",
      "Plano alimentar macro-calculado",
      "Suporte no WhatsApp em até 24h",
      "Check-in quinzenal de evolução",
    ],
    cta: "Selecionar mensal",
    wa: "Olá! Quero começar no plano MENSAL da LF TEAM.",
    featured: false,
  },
  {
    id: "trimestral",
    name: "Trimestral",
    price: "R$ 417,90",
    period: "/3 meses",
    note: "Equivale a R$ 139,30/mês — economize R$ 31,80 vs. mensal.",
    features: [
      "Tudo do plano Mensal",
      "Ajustes ilimitados de carga e dieta",
      "Check-in prioritário no WhatsApp",
      "Guia científico de suplementação",
    ],
    cta: "Começar agora",
    wa: "Olá! Quero começar no plano TRIMESTRAL da LF TEAM.",
    featured: true,
  },
];

function PlanCard({ plan }) {
  const inner = (
    <>
      {plan.featured && (
        <span className="self-start bg-black px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-white">
          Mais escolhido
        </span>
      )}
      <h3 className="font-display text-2xl font-black uppercase tracking-tight md:text-3xl">
        {plan.name}
      </h3>
      <div className="mt-6 flex items-end gap-2">
        <span className="font-display text-5xl font-black tracking-tight md:text-6xl">
          {plan.price}
        </span>
        <span
          className={`pb-1.5 font-mono text-xs ${
            plan.featured ? "text-black/50" : "text-white/40"
          }`}
        >
          {plan.period}
        </span>
      </div>
      <p
        className={`mt-3 font-mono text-[11px] leading-relaxed ${
          plan.featured ? "text-black/60" : "text-white/45"
        }`}
      >
        {plan.note}
      </p>
      <ul className="mt-8 flex flex-1 flex-col gap-3">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-3 text-sm md:text-base">
            <Check
              className={`mt-1 h-4 w-4 shrink-0 ${
                plan.featured ? "text-black" : "text-white"
              }`}
            />
            {f}
          </li>
        ))}
      </ul>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`plan-select-${plan.id}`}
        className={`mt-10 ${plan.featured ? "btn-dark" : "btn-primary"} w-full`}
      >
        {plan.cta}
      </a>
    </>
  );

  return (
    <motion.article
      {...reveal}
      className={`flex flex-col p-8 md:p-10 ${
        plan.featured
          ? "bg-white text-black md:-translate-y-2 md:shadow-[0_0_60px_rgba(255,255,255,0.12)]"
          : "border border-white/15 bg-card text-white"
      }`}
    >
      {inner}
    </motion.article>
  );
}

export default function Plans() {
  return (
    <section id="planos" className="section-pad border-t border-white/10">
      <div className="container-x">
        <motion.div {...reveal} className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="overline-label">Investimento</p>
            <h2 className="h2-display mt-4 text-white">
              Escolha
              <br />
              <span className="text-stroke">seu plano.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-white/55 md:text-base">
            Sem contrato de fidelidade. Protocolo individual entregue em até
            48 horas após a anamnese.
          </p>
        </motion.div>

        <div className="mt-12 grid gap-4 md:grid-cols-2">
          {PLANS.map((p) => (
            <PlanCard key={p.id} plan={p} />
          ))}
        </div>

        <p className="mt-8 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-white/35">
          Planos semestral e anual sob consulta no WhatsApp
        </p>
      </div>
    </section>
  );
}
